<div class="footer-bottom">
  <div>{{copyRightText}}</div>
  <cx-media [container]="imageData" class="img-styles" loading="lazy"/>
</div>